export const spacing = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
  xxl: 64,
} as const;

// Minimum touch target for elderly users: 48x48 pixels
// Recommended: 56x56 pixels or larger
export const touchTargets = {
  minimum: 48,
  recommended: 56,
  large: 72, // For primary actions
} as const;

export const borderRadius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  round: 9999,
} as const;
